module.exports = __webpack_public_path__ + "static/media/1.a97a99b2.jpg";